export class AdvetisingPlayer {
    // staff
    adInitPlayer;

    constructor() {
        this.init();
    }

    init() {
        this.adInitPlayer = $('.ad-init--player');
        if (!this.adInitPlayer.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.adFinalPlayer = $('.ad-final--player');
        if (!this.adFinalPlayer.length) {
            return;
        }

        this.adFinalPlayer.replaceWith(this.adInitPlayer);
    }
}
